import * as React from 'react';
import { useEffect } from 'react';
import ProjectLayout from '../../ProjectLayout';
import { useDispatch } from 'react-redux';
import { useMount } from '../../../core/hooks/useMount';
import { openMenuAction } from '../../sideMenu/openMenuAction';
import { css } from '@emotion/core';
import { useAppState } from '../../../core/redux/hooks';
import { useHistory } from 'react-router-dom';
import { isRtl } from '../../../localization/module';
import { makeRoutes } from '../../../navigation/routes';
import { useProjIds } from '../../../navigation/hooks';


const styles = {
  iframe: css`
    width: 100%;
    height: calc(100vh - 51px);
  `,
};

type Props = {
  className?: string;
};


/**
 * SelfSurvey: a component that displays the survey application
 *
 * PureComponent: true
 * Redux Connected: false
 */
const SelfSurvey: React.FC<Props> = props => {
  const selfSurveyUrl = useAppState(state => state.projectSummary?.selfSurveyUrl);
  const dispatch      = useDispatch();
  const history       = useHistory();

  useMount(() => { window.setTimeout(() => dispatch(openMenuAction(false)), 200); });

  const projIds = useProjIds();

  useEffect(
    () => {
      //on survey complete or 'finish later', go back to dashboard
      const handleFinish = (event: MessageEvent) => {
        if (event.data === 'finish') {
          dispatch(openMenuAction(true));
          history.push(makeRoutes(projIds.participantId, projIds.projDisplayId).Project);
        }
      };

      window.addEventListener('message', handleFinish, false);

      // Return cleanup function to unregister the event listener when the component unmounts
      return () => window.removeEventListener('message', handleFinish, false);
    },
    [projIds.participantId, projIds.projDisplayId, history, dispatch],
  );

  const rtl    = useAppState(state => isRtl(state.locale.textDirection));
  const langId = useAppState(state => state.locale.lang.languageId);
 

  return (
    <ProjectLayout
      floatMenu={true}
      className={props.className}
      contentStyle={rtl ? css`padding: 0 50px 0 0; max-width: none;` : css`padding: 0 0 0 50px; max-width: none;`}
    >
      <iframe
        frameBorder={0}
        css={styles.iframe}
        src={selfSurveyUrl + `&langid=${langId}` }
        title={'self-survey'}
      />
    </ProjectLayout>
  );
};

export default SelfSurvey;
